export default __webpack_public_path__ + "static/media/banner1.ed109c8d.jpg";